import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/vectors/ig-icon.svg'
import _imports_1 from '../assets/vectors/fb-icon.svg'
import _imports_2 from '../assets/vectors/twitter-icon.svg'
import _imports_3 from '../assets/vectors/linkedin.svg'
import _imports_4 from '../assets/images/icims-logo.png'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "locale-changer" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "copyright" }
const _hoisted_9 = { class: "links" }
const _hoisted_10 = {
  href: "https://www.icims.com/legal/privacy-notice-services/",
  target: "_blank"
}
const _hoisted_11 = {
  href: "https://www.altrulabs.com/terms",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"media-icons\" data-v-797ceaaa><a href=\"https://www.instagram.com/icims_inc/\" target=\"_blank\" data-v-797ceaaa><img alt=\"instagram\" src=\"" + _imports_0 + "\" class=\"logo\" data-v-797ceaaa></a><a href=\"https://www.facebook.com/iCIMS/\" target=\"_blank\" data-v-797ceaaa><img alt=\"facebook\" src=\"" + _imports_1 + "\" class=\"logo\" data-v-797ceaaa></a><a href=\"https://twitter.com/iCIMS\" target=\"_blank\" data-v-797ceaaa><img alt=\"twitter\" src=\"" + _imports_2 + "\" class=\"logo\" data-v-797ceaaa></a><a href=\"https://www.linkedin.com/company/icims/\" target=\"_blank\" data-v-797ceaaa><img alt=\"twitter\" src=\"" + _imports_3 + "\" class=\"logo\" data-v-797ceaaa></a></div>", 1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'language'] }),
            _withDirectives(_createElementVNode("select", {
              title: $setup.t('LANGUAGE SELECTOR'),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.locale) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableLocales, (locale) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: `locale-${locale}`,
                  value: locale
                }, _toDisplayString($setup.getDisplayName(locale)), 9, _hoisted_6))
              }), 128))
            ], 8, _hoisted_5), [
              [_vModelSelect, $setup.locale]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " ", 1),
            _cache[2] || (_cache[2] = _createElementVNode("a", {
              href: "https://www.icims.com/",
              target: "_blank"
            }, [
              _createElementVNode("img", {
                alt: "iCIMS logo site",
                src: _imports_4,
                class: "logo site"
              })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", _hoisted_10, _toDisplayString($setup.t('PRIVACY POLICY')), 1),
            _createElementVNode("a", _hoisted_11, _toDisplayString($setup.t('TERMS & CONDITIONS')), 1)
          ])
        ])
      ])
    ])
  ]))
}